import React from 'react';
import { Button } from './Button';
import { ArrowRight } from 'lucide-react';
import { useModal } from './ModalContext';
export const CallToAction = () => {
  const {
    openTalkToUs
  } = useModal();
  return <section id="cta" className="w-full bg-white py-section-mobile md:py-section-desktop relative overflow-hidden" data-id="element-44">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-45">
        <div className="max-w-6xl mx-auto" data-id="element-46">
          <div className="grid lg:grid-cols-12 gap-8 lg:gap-20 items-center" data-id="element-47">
            <div className="lg:col-span-12" data-id="element-48"></div>
            <div className="lg:col-span-12" data-id="element-49">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3KFpKL4x8ZRHY6kZ6KEr1H/image.png" alt="Decorative divider with plant illustrations" className="w-full mx-auto mb-8" data-id="element-50" />
              <div className="bg-gradient-to-br from-primary-50 to-blue-50 rounded-2xl shadow-glow p-6 md:p-10 lg:p-12 space-y-5 border border-primary-100 transition-all duration-300 hover:shadow-glow-hover backdrop-blur-sm lg:max-w-[80%] lg:mx-auto" data-id="element-51">
                <h2 className="text-h2-mobile md:text-h2-desktop font-serif font-normal text-cyan-800 leading-tight text-center" data-id="element-52">
                  Bring Nisa to your school or district
                </h2>
                <div className="space-y-3 max-w-xl mx-auto" data-id="element-53">
                  <p className="text-base md:text-lg text-gray-600 leading-relaxed text-center" data-id="element-54">
                    Request a walkthrough to learn how Nisa can strengthen
                    coaching in your school or district.
                  </p>
                  <p className="text-center" data-id="element-55">
                    <a href="/schools" className="text-base text-primary-500 hover:text-primary-600 underline underline-offset-2 transition-colors duration-200" data-id="element-56">
                      Learn how Nisa works for schools and districts
                    </a>
                  </p>
                </div>
                <div className="flex justify-center pt-1" data-id="element-57">
                  <Button type="button" size="lg" onClick={openTalkToUs} data-id="element-58">
                    Request a Nisa demo
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};